import * as echarts from 'echarts' 
import {useEffect} from 'react'
import 'echarts-gl';


export default function DriveImage() {
  useEffect(() => {
    var DriveImage;
    if (DriveImage !== null && DriveImage !== undefined && DriveImage !== ''){
      DriveImage.dispose();
    }
    

    var dom = document.getElementById('DriveImage');
    DriveImage = echarts.init(dom);
    
    var option = null;

    var schema = [
      { name: 'date', index: 0, text: 'ID' },
      { name: 'lable1', index: 1, text: '飞行员' },
      { name: 'lable2', index: 2, text: '变速王' },
      { name: 'lable3', index: 3, text: '善变者' },
      { name: 'lable4', index: 4, text: ' 急急国王' },
      { name: 'lable5', index: 5, text: '摇摆人' },
      { name: 'grades', index: 6, text: '标签' },
    ];
    var lineStyle = {
      width: 1,
      opacity: 0.5
    };
    
    DriveImage.setOption(option = {
      baseOption: {
        backgroundColor: '#1A2942',
        timeline: {
            axisType: 'category',
            autoPlay: true,
            show: true,
            playInterval: 1000,
            data: ['272045882', '174412608', '248594422', '277882251', '278063371', '280843745',
                '281016551', '281218691', '285415814', '309664197', '288798709', '309510952', '310106373'
            ],
            realtime: true,
            loop: true,
            lineStyle: {
                color: '#466872',
                width: 2,
            },
            label: {
                color: '#5cc5da',
                fontSize: 14,
            },
        },
        title: {
            text: "车辆驾驶画像可视分析",
            left: 'center',
            textStyle: {
                color: '#358BA3'
            }
        },
        tooltip: {
            trigger: 'item',
            padding: 10,
            backgroundColor: '#222',
            borderColor: '#777',
            borderWidth: 1
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        roamController: {
            show: true,
            left: 'right',
            mapTypeControl: {
              'China': true
            }
        },
        visualMap: {
          show: true,
          min: 0,
          max: 200,
          dimension: 5,
          inRange: {
            color: ['#d94e5d', '#eac736', '#50a3ba'].reverse()
          }
        },
        parallelAxis: [
          {
            dim: 0,
            name: schema[0].text,
            inverse: true,
            type: 'category',
            data: ['272045882', '174412608', '248594422', '277882251', '278063371', '280843745',
                  '281016551', '281218691', '285415814', '309664197', '288798709', '309510952', '310106373'],
            nameLocation: 'start'
          },
          { dim: 1, name: schema[1].text },
          { dim: 2, name: schema[2].text },
          { dim: 3, name: schema[3].text },
          { dim: 4, name: schema[4].text },
          { dim: 5, name: schema[5].text },
          {
            dim: 6,
            name: schema[6].text,
            type: 'category',
            data: ['一路顺风', '有惊无险', '慌不择路', '横冲直撞', '马路杀手', '亡命之徒']
          }
        ],
  
        parallel: {
          left: '10%',
          right: '10%',
          bottom: 100,
          parallelAxisDefault: {
            type: 'value',
            name: 'lable1',
            nameLocation: 'end',
            nameGap: 20,
            nameTextStyle: {
              color: '#fff',
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: '#aaa'
              }
            },
            axisTick: {
              lineStyle: {
                color: '#777'
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              color: '#fff'
            }
          }
        },
        series: [{
          type: 'parallel',
          lineStyle: lineStyle,
        }]
    },
    options: [
      {
          title: {
              text: '车辆驾驶画像可视分析——ID: 272045882'
          },
          series: [{
              data:
              [
                [0, 0.00, 0.00, 0.00, 2.58, 166.55, 1.00],
                [0, 0.00, 0.00, 0.00, 2.58, 0.00, 0.00],
                [0, 12.51, 0.00, 3.47, 2.54, 8.60, 0.00],
                [0, 10.21, 0.00, 1.10, 2.55, 22.60, 0.00],
                [0, 0.00, 0.00, 2.29, 2.58, 31.20, 0.00],
                [0, 0.00, 0.00, 1.14, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.57, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.29, 2.58, 0.00, 0.00],
                [0, 10.84, 0.00, 2.87, 2.54, 31.72, 0.00],
                [0, 0.00, 0.00, 1.58, 2.58, 31.72, 0.00],
                [0, 0.00, 0.00, 0.79, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.39, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.20, 2.58, 0.00, 0.00],
                [0, 13.09, 0.00, 3.54, 2.58, 20.13, 0.00],
                [0, 0.00, 0.00, 1.87, 2.58, 20.13, 0.00],
                [0, 0.00, 0.00, 0.93, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.47, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.23, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.12, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.06, 2.58, 0.00, 0.00],
                [0, 11.59, 0.00, 3.19, 2.53, 32.30, 0.00],
                [0, 0.00, 0.00, 1.62, 1.99, 179.29, 1.00],
                [0, 0.00, 0.00, 0.81, 1.99, 0.00, 0.00],
                [0, 21.13, 0.00, 5.46, 2.56, 118.26, 1.00],
                [0, 0.00, 0.00, 3.14, 1.99, 118.26, 0.00],
                [0, 0.00, 0.00, 1.57, 2.58, 157.54, 1.00],
                [0, 0.00, 0.00, 0.78, 1.99, 157.36, 1.00],
                [0, 0.00, 0.00, 0.39, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.20, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.10, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.05, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.02, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.01, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.01, 2.59, 123.09, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 123.09, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [0, 0.88, 0.00, 0.24, 2.59, 122.68, 1.00],
                [0, 0.00, 0.00, 0.12, 2.59, 1.08, 0.00],
                [0, 0.00, 0.00, 0.06, 1.99, 123.09, 1.00],
                [0, 0.00, 0.00, 0.03, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.02, 1.99, 0.38, 0.00],
                [0, 23.98, 0.00, 6.65, 1.98, 70.03, 1.00],
                [0, 0.00, 0.00, 3.33, 1.99, 70.03, 0.00],
                [0, 0.00, 0.00, 1.67, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.83, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.42, 2.58, 157.54, 1.00],
                [0, 2.15, 0.00, 0.39, 2.59, 49.23, 0.00],
                [0, 0.00, 0.00, 0.40, 1.99, 123.40, 1.00],
                [0, 0.00, 0.00, 0.20, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.10, 1.99, 0.38, 0.00],
                [0, 1.06, 0.00, 0.24, 2.59, 122.37, 1.00],
                [0, 0.00, 0.00, 0.17, 1.99, 122.64, 1.00],
                [0, 0.00, 0.00, 0.09, 2.58, 157.26, 1.00],
                [0, 0.00, 0.00, 0.04, 1.99, 157.07, 1.00],
                [0, 11.67, 0.00, 3.22, 2.55, 121.73, 1.00],
                [0, 0.00, 0.00, 1.63, 1.99, 122.01, 1.00],
                [0, 0.00, 0.00, 0.82, 1.99, 0.00, 0.00],
                [0, 20.03, 0.00, 5.16, 2.68, 133.84, 2.00],
                [0, 0.00, 0.00, 2.99, 1.99, 133.84, 1.00],
                [0, 0.00, 0.00, 1.49, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.75, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.37, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.19, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.09, 2.58, 157.07, 1.00],
                [0, 0.00, 0.00, 0.05, 1.99, 157.07, 1.00],
                [0, 24.64, 0.00, 6.82, 2.04, 34.82, 1.00],
                [0, 0.00, 0.00, 3.43, 2.59, 93.16, 0.00],
                [0, 23.61, 0.00, 4.84, 2.74, 29.30, 1.00],
                [0, 0.00, 0.00, 4.14, 1.99, 114.40, 1.00],
                [0, 0.00, 0.00, 2.07, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 1.03, 2.59, 123.09, 1.00],
                [0, 0.00, 0.00, 0.52, 1.99, 122.83, 1.00],
                [0, 0.00, 0.00, 0.26, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.13, 1.99, 0.38, 0.00],
                [0, 1.95, 0.00, 0.48, 2.59, 123.63, 1.00],
                [0, 0.00, 0.00, 0.30, 2.59, 1.89, 0.00],
                [0, 0.00, 0.00, 0.15, 1.99, 123.09, 1.00],
                [0, 0.99, 0.00, 0.20, 2.59, 124.20, 1.00],
                [0, 0.00, 0.00, 0.18, 1.99, 123.93, 1.00],
                [0, 0.00, 0.00, 0.09, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.04, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.02, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.01, 2.58, 157.54, 1.00],
                [0, 0.00, 0.00, 0.01, 1.99, 157.54, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [0, 23.67, 0.00, 6.57, 2.78, 113.97, 1.00],
                [0, 0.00, 0.00, 3.29, 1.99, 114.30, 0.00],
                [0, 0.00, 0.00, 1.64, 2.59, 124.49, 1.00],
                [0, 0.00, 0.00, 0.82, 1.99, 124.22, 1.00],
                [0, 0.00, 0.00, 0.41, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.21, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.10, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.05, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.03, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.00, 2.58, 157.07, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 157.26, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [0, 24.73, 0.00, 6.87, 2.51, 93.05, 1.00],
                [0, 0.00, 0.00, 3.44, 1.99, 92.69, 0.00],
                [0, 0.00, 0.00, 1.72, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.86, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.43, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.21, 2.58, 157.54, 1.00],
                [0, 0.00, 0.00, 0.11, 1.99, 157.36, 1.00],
                [0, 0.00, 0.00, 0.05, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.03, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.01, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.00, 2.59, 124.49, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 124.22, 1.00],
                [0, 0.00, 0.00, 0.00, 2.58, 157.36, 1.00],
                [0, 0.00, 0.00, 0.00, 1.99, 157.54, 1.00],
                [0, 3.44, 0.00, 0.96, 2.59, 124.49, 1.00],
                [0, 0.00, 0.00, 0.48, 1.99, 124.22, 1.00],
                [0, 0.00, 0.00, 0.24, 2.58, 157.36, 1.00],
                [0, 0.00, 0.00, 0.12, 2.58, 0.44, 0.00],
                [0, 0.00, 0.00, 0.06, 1.99, 157.26, 1.00],
                [0, 0.00, 0.00, 0.03, 2.59, 123.09, 1.00],
                [0, 0.00, 0.00, 0.01, 1.99, 123.09, 1.00],
                [0, 4.22, 0.00, 1.17, 2.59, 127.97, 1.00],
                [0, 0.00, 0.00, 0.59, 2.59, 10.87, 0.00],
                [0, 20.70, 0.00, 5.46, 3.03, 42.34, 1.00],
                [0, 0.00, 0.00, 3.02, 2.59, 42.34, 0.00],
                [0, 0.00, 0.00, 1.51, 1.99, 123.09, 1.00],
                [0, 23.25, 0.00, 5.70, 2.98, 144.40, 2.00],
                [0, 0.00, 0.00, 3.61, 1.99, 144.40, 1.00],
                [0, 0.00, 0.00, 1.80, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.90, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.45, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.23, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.11, 2.59, 124.49, 1.00],
                [0, 10.68, 0.00, 2.91, 2.14, 121.24, 1.00],
                [0, 0.00, 0.00, 1.51, 1.99, 3.88, 0.00],
                [0, 0.00, 0.00, 0.76, 2.59, 123.09, 1.00],
                [0, 0.00, 0.00, 0.38, 1.99, 123.09, 1.00],
                [0, 0.00, 0.00, 0.19, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.09, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.05, 1.99, 0.00, 0.00],
                [0, 0.00, 0.00, 0.02, 2.59, 124.49, 1.00],
                [0, 0.00, 0.00, 0.01, 1.99, 124.49, 1.00],
                [0, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [0, 0.00, 0.00, 0.00, 2.58, 157.36, 1.00],
                [0, 24.75, 0.00, 6.87, 2.82, 101.86, 1.00],
                [0, 0.00, 0.00, 3.44, 1.99, 101.38, 0.00],
                [0, 0.00, 0.00, 1.72, 1.99, 0.38, 0.00],
                [0, 22.75, 0.00, 5.46, 2.61, 116.50, 1.00],
                [0, 0.00, 0.00, 3.59, 2.58, 71.66, 0.00],
                [0, 0.00, 0.00, 1.80, 2.58, 0.00, 0.00],
                [0, 0.00, 0.00, 0.90, 1.99, 157.36, 1.00],
                [0, 24.46, 0.00, 6.34, 2.01, 72.44, 1.00],
                [0, 0.00, 0.00, 3.62, 1.96, 75.49, 0.00],
            ]
        }]
      },
      {
        title: {
            text: '车辆驾驶画像可视分析——ID: 174412608'
        },
        series: [{
            data:
            [
              [1, 29.59, 0.00, 8.22, 0.41, 123.42, 2.00],
              [1, 40.69, 0.00, 7.19, 0.56, 54.29, 1.00],
              [1, 36.46, 0.00, 2.42, 0.52, 94.26, 0.00],
              [1, 29.03, 0.00, 0.85, 0.40, 150.16, 1.00],
              [1, 39.42, 0.00, 2.46, 0.55, 28.42, 0.00],
              [1, 28.46, 0.00, 1.81, 0.40, 30.02, 0.00],
              [1, 30.12, 0.00, 0.45, 1.10, 79.33, 0.00],
              [1, 32.69, 0.00, 0.49, 0.48, 89.62, 0.00],
              [1, 17.12, 0.00, 4.08, 0.40, 43.53, 1.00],
              [1, 24.27, 0.00, 0.05, 0.35, 26.23, 0.00],
              [1, 35.36, 0.00, 3.05, 0.49, 214.72, 1.00],
              [1, 40.24, 0.00, 2.88, 0.56, 52.80, 0.00],
              [1, 18.30, 0.00, 4.65, 0.29, 142.36, 2.00],
              [1, 35.89, 0.00, 2.56, 1.12, 71.50, 0.00],
              [1, 37.72, 0.00, 1.79, 0.54, 210.00, 1.00],
              [1, 38.86, 0.00, 1.21, 0.55, 12.69, 0.00],
              [1, 23.79, 0.00, 3.58, 0.38, 134.83, 1.00],
              [1, 18.66, 0.00, 3.22, 0.26, 26.24, 0.00],
              [1, 40.10, 0.00, 4.35, 0.55, 145.59, 2.00],
              [1, 25.91, 0.00, 1.77, 0.38, 115.29, 0.00],
              [1, 27.03, 0.00, 0.57, 0.88, 65.85, 0.00],
              [1, 38.26, 0.00, 2.83, 0.54, 196.73, 1.00],
              [1, 39.25, 0.00, 1.69, 0.55, 10.76, 0.00],
              [1, 36.66, 0.00, 0.13, 0.53, 29.47, 0.00],
              [1, 26.61, 0.00, 2.73, 0.38, 154.31, 1.00],
              [1, 31.68, 0.00, 0.04, 1.12, 77.04, 0.00],
              [1, 21.90, 0.00, 2.69, 0.05, 46.13, 0.00],
              [1, 23.03, 0.00, 1.03, 0.18, 5.06, 0.00],
              [1, 40.34, 0.00, 4.29, 0.56, 125.76, 2.00],
              [1, 30.70, 0.00, 0.53, 0.44, 68.91, 0.00],
              [1, 25.20, 0.00, 1.79, 0.38, 14.23, 0.00],
              [1, 17.30, 0.00, 3.09, 0.47, 16.01, 0.00],
              [1, 26.51, 0.00, 1.01, 0.80, 47.96, 0.00],
              [1, 35.12, 0.00, 2.90, 1.13, 31.55, 0.00],
              [1, 24.49, 0.00, 1.50, 0.38, 80.84, 0.00],
              [1, 40.57, 0.00, 3.72, 0.56, 102.33, 0.00],
              [1, 35.49, 0.00, 0.45, 1.13, 167.67, 1.00],
              [1, 40.48, 0.00, 1.61, 0.56, 141.58, 1.00],
              [1, 38.07, 0.00, 0.14, 0.54, 38.72, 0.00],
              [1, 22.43, 0.00, 4.28, 0.38, 38.50, 1.00],
              [1, 17.65, 0.00, 3.47, 0.35, 20.69, 0.00],
              [1, 16.66, 0.00, 2.01, 0.46, 4.60, 0.00],
              [1, 35.62, 0.00, 4.26, 0.50, 186.60, 2.00],
              [1, 33.11, 0.00, 1.43, 1.13, 226.48, 1.00],
              [1, 19.05, 0.00, 3.19, 0.22, 56.03, 0.00],
              [1, 28.25, 0.00, 0.96, 1.05, 46.79, 0.00],
              [1, 40.89, 0.00, 3.99, 0.56, 111.82, 0.00],
              [1, 32.42, 0.00, 0.36, 1.12, 115.20, 0.00],
              [1, 35.90, 0.00, 0.79, 0.51, 224.29, 1.00],
              [1, 23.78, 0.00, 2.97, 0.28, 208.83, 1.00],
              [1, 39.07, 0.00, 2.76, 0.55, 175.56, 1.00],
              [1, 40.34, 0.00, 1.73, 0.56, 87.86, 0.00],
              [1, 38.78, 0.00, 0.43, 0.55, 6.83, 0.00],
              [1, 23.55, 0.00, 4.01, 0.25, 80.82, 1.00],
              [1, 24.98, 0.00, 1.61, 0.49, 9.57, 0.00],
              [1, 16.61, 0.00, 3.13, 0.48, 35.27, 0.00],
              [1, 40.41, 0.00, 5.05, 0.56, 109.24, 1.00],
              [1, 30.14, 0.00, 0.33, 0.43, 77.28, 0.00],
              [1, 40.35, 0.00, 2.67, 0.56, 72.80, 0.00],
              [1, 31.97, 0.00, 0.99, 0.47, 67.70, 0.00],
              [1, 33.98, 0.00, 0.06, 0.46, 157.46, 1.00],
              [1, 24.82, 0.00, 2.51, 0.45, 225.16, 1.00],
              [1, 34.67, 0.00, 1.48, 0.48, 221.36, 1.00],
              [1, 39.41, 0.00, 2.06, 0.55, 45.58, 0.00],
              [1, 40.45, 0.00, 1.32, 0.56, 33.68, 0.00],
              [1, 33.09, 0.00, 1.38, 0.45, 88.60, 0.00],
              [1, 17.62, 0.00, 4.99, 0.46, 195.46, 2.00],
              [1, 22.76, 0.00, 1.07, 0.15, 27.39, 0.00],
              [1, 19.83, 0.00, 1.35, 0.16, 10.81, 0.00],
              [1, 28.73, 0.00, 1.80, 1.07, 46.37, 0.00],
              [1, 37.34, 0.00, 3.29, 0.54, 98.36, 0.00],
              [1, 20.58, 0.00, 3.01, 0.09, 65.39, 0.00],
              [1, 22.19, 0.00, 1.06, 0.08, 6.04, 0.00],
              [1, 24.47, 0.00, 0.10, 0.38, 11.78, 0.00],
          ]
        }]
        },
        {
          title: {
              text: '车辆驾驶画像可视分析——ID: 248594422'
          },
          series: [{
              data:
              [
                [2, 0.00, 0.00, 0.00, 2.60, 229.07, 1.00],
                [2, 0.00, 0.00, 0.00, 2.60, 0.00, 0.00],
                [2, 0.00, 0.00, 0.00, 2.57, 271.78, 1.00],
                [2, 52.35, 0.00, 14.54, 2.61, 202.63, 3.00],
                [2, 0.00, 0.00, 7.27, 2.60, 69.15, 1.00],
                [2, 0.00, 0.00, 3.64, 2.60, 0.00, 0.00],
                [2, 48.79, 0.00, 11.73, 2.60, 57.69, 1.00],
                [2, 0.00, 0.00, 7.69, 2.57, 213.77, 2.00],
                [2, 0.00, 0.00, 3.84, 2.60, 271.45, 1.00],
                [2, 0.00, 0.00, 1.92, 2.60, 0.00, 0.00],
                [2, 29.72, 0.00, 7.29, 2.60, 259.85, 2.00],
                [2, 35.22, 0.00, 5.17, 2.60, 5.16, 1.00],
                [2, 0.00, 0.00, 7.20, 2.57, 17.09, 1.00],
                [2, 61.27, 0.00, 13.42, 2.61, 54.91, 2.00],
                [2, 0.00, 0.00, 10.31, 2.60, 216.87, 2.00],
                [2, 0.00, 0.00, 5.15, 2.60, 0.00, 1.00],
                [2, 0.00, 0.00, 2.58, 2.58, 271.78, 1.00],
                [2, 0.00, 0.00, 1.29, 2.60, 271.78, 1.00],
                [2, 0.00, 0.00, 0.64, 2.60, 0.00, 0.00],
                [2, 0.00, 0.00, 0.32, 2.57, 271.78, 1.00],
                [2, 20.96, 0.00, 5.66, 2.59, 260.57, 2.00],
                [2, 0.00, 0.00, 2.99, 2.58, 260.57, 1.00],
                [2, 0.00, 0.00, 1.50, 2.58, 0.00, 0.00],
                [2, 4.15, 0.00, 0.40, 2.60, 271.69, 1.00],
                [2, 0.00, 0.00, 0.95, 2.58, 271.69, 1.00],
                [2, 66.98, 0.00, 18.13, 2.62, 134.74, 3.00],
                [2, 0.00, 0.00, 9.54, 2.60, 137.04, 2.00],
                [2, 0.00, 0.00, 4.77, 2.58, 271.78, 2.00],
                [2, 0.00, 0.00, 2.39, 2.58, 0.00, 0.00],
                [2, 0.00, 0.00, 1.19, 2.57, 0.00, 0.00],
                [2, 0.00, 0.00, 0.60, 2.57, 0.33, 0.00],
                [2, 0.00, 0.00, 0.30, 2.58, 0.33, 0.00],
                [2, 0.00, 0.00, 0.15, 2.60, 271.78, 1.00],
                [2, 0.00, 0.00, 0.07, 2.57, 271.78, 1.00],
                [2, 0.00, 0.00, 0.04, 2.60, 271.78, 1.00],
                [2, 56.15, 0.00, 15.58, 2.61, 226.60, 3.00],
                [2, 0.00, 0.00, 7.81, 2.60, 226.60, 2.00],
                [2, 0.00, 0.00, 3.90, 2.60, 0.00, 0.00],
                [2, 0.00, 0.00, 1.95, 2.57, 271.78, 1.00],
                [2, 50.67, 0.00, 13.10, 2.60, 208.43, 3.00],
                [2, 0.00, 0.00, 7.53, 2.60, 63.36, 1.00],
                [2, 0.00, 0.00, 3.76, 2.60, 0.00, 0.00],
                [2, 69.70, 0.00, 17.48, 2.60, 183.25, 3.00],
                [2, 0.00, 0.00, 10.62, 2.60, 183.25, 2.00],
                [2, 0.00, 0.00, 5.31, 2.60, 0.00, 1.00],
                [2, 18.38, 0.00, 2.45, 2.59, 4.89, 0.00],
                [2, 27.80, 0.00, 3.84, 2.60, 266.29, 1.00],
                [2, 0.00, 0.00, 5.80, 2.60, 261.39, 2.00],
                [2, 0.00, 0.00, 2.90, 2.60, 0.00, 0.00],
                [2, 0.00, 0.00, 1.45, 2.58, 271.78, 1.00],
                [2, 0.00, 0.00, 0.73, 2.60, 271.78, 1.00],
                [2, 0.00, 0.00, 0.36, 2.58, 271.78, 1.00],
                [2, 46.69, 0.00, 12.79, 2.60, 219.54, 2.00],
                [2, 0.00, 0.00, 6.57, 2.60, 52.25, 1.00],
                [2, 61.34, 0.00, 13.75, 2.62, 100.47, 2.00],
                [2, 0.00, 0.00, 10.16, 2.60, 100.47, 1.00],
                [2, 0.64, 0.00, 4.90, 2.57, 271.36, 2.00],
                [2, 0.00, 0.00, 2.63, 2.60, 271.36, 1.00],
                [2, 0.00, 0.00, 1.31, 2.58, 271.78, 1.00],
                [2, 0.00, 0.00, 0.66, 2.58, 0.00, 0.00],
                [2, 43.89, 0.00, 11.86, 2.49, 42.93, 1.00],
                [2, 0.00, 0.00, 6.26, 2.58, 42.93, 1.00],
                [2, 0.00, 0.00, 3.13, 2.58, 0.00, 0.00],
                [2, 0.00, 0.00, 1.57, 2.58, 0.00, 0.00],
                [2, 53.38, 0.00, 14.05, 2.57, 69.61, 2.00],
                [2, 0.00, 0.00, 7.81, 2.58, 69.61, 1.00],
                [2, 30.84, 0.00, 4.66, 2.53, 16.96, 1.00],
                [2, 0.00, 0.00, 6.23, 2.58, 16.96, 1.00],
                [2, 42.22, 0.00, 8.61, 2.48, 38.09, 1.00],
                [2, 0.00, 0.00, 7.42, 2.58, 38.09, 1.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 277882251'
            },
            series: [{
              data:
              [
                [3, 0.00, 0.00, 0.06, 1.08, 0.19, 0.00],
                [3, 16.62, 0.00, 4.59, 0.93, 23.77, 1.00],
                [3, 0.00, 0.00, 2.32, 1.08, 23.59, 0.00],
                [3, 0.00, 0.00, 1.16, 1.08, 0.18, 0.00],
                [3, 0.00, 0.00, 0.58, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.29, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.15, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.07, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.04, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.02, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.01, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.10, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.10, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.02, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.03, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.10, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.10, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.10, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.02, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.01, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.04, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.11, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.02, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.10, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.00, 0.00],
                [3, 0.00, 0.00, 0.00, 1.08, 0.09, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 278063371'
            },
            series: [{
              data:
              [
                [4, 0.00, 0.00, 0.00, 1.96, 219.03, 1.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.38, 0.00],
                [4, 36.60, 0.00, 10.17, 1.93, 74.48, 1.00],
                [4, 38.22, 0.00, 5.53, 1.93, 10.37, 1.00],
                [4, 0.00, 0.00, 7.85, 1.96, 84.89, 1.00],
                [4, 35.71, 0.00, 5.99, 1.93, 68.55, 1.00],
                [4, 33.34, 0.00, 2.34, 1.92, 13.46, 0.00],
                [4, 0.00, 0.00, 8.09, 1.96, 55.16, 1.00],
                [4, 0.00, 0.00, 4.05, 1.96, 0.00, 1.00],
                [4, 19.30, 0.00, 3.34, 1.91, 15.66, 0.00],
                [4, 37.85, 0.00, 6.82, 1.94, 100.78, 1.00],
                [4, 0.00, 0.00, 7.10, 1.96, 116.19, 1.00],
                [4, 0.00, 0.00, 3.55, 1.96, 0.62, 0.00],
                [4, 0.00, 0.00, 1.78, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.89, 1.96, 0.14, 0.00],
                [4, 37.92, 0.00, 10.09, 1.93, 82.78, 1.00],
                [4, 0.00, 0.00, 5.49, 1.96, 82.72, 1.00],
                [4, 0.00, 0.00, 2.74, 1.96, 0.00, 0.00],
                [4, 38.86, 0.00, 9.42, 1.93, 91.30, 1.00],
                [4, 0.00, 0.00, 6.08, 1.96, 91.37, 1.00],
                [4, 0.00, 0.00, 3.04, 1.96, 0.14, 0.00],
                [4, 0.00, 0.00, 1.52, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.76, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.38, 1.96, 0.38, 0.00],
                [4, 13.38, 0.00, 3.53, 1.95, 148.30, 1.00],
                [4, 0.00, 0.00, 1.95, 1.96, 148.14, 1.00],
                [4, 0.00, 0.00, 0.98, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.49, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.24, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.12, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.06, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.03, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.02, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.01, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [4, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 280843745'
            },
            series: [{
              data:
              [
                [5, 5.71, 0.00, 1.59, 1.07, 118.51, 0.00],
                [5, 4.50, 0.00, 0.46, 1.05, 20.50, 0.00],
                [5, 5.06, 0.00, 0.38, 1.06, 19.30, 0.00],
                [5, 5.79, 0.00, 0.39, 1.08, 9.55, 0.00],
                [5, 5.52, 0.00, 0.12, 1.11, 10.46, 0.00],
                [5, 5.20, 0.00, 0.03, 1.08, 28.01, 0.00],
                [5, 5.11, 0.00, 0.04, 1.14, 23.38, 0.00],
                [5, 5.30, 0.00, 0.03, 1.12, 1.22, 0.00],
                [5, 5.20, 0.00, 0.01, 1.08, 22.74, 0.00],
                [5, 5.50, 0.00, 0.08, 1.12, 28.90, 0.00],
                [5, 5.86, 0.00, 0.14, 1.16, 10.93, 0.00],
                [5, 5.99, 0.00, 0.10, 1.08, 4.15, 0.00],
                [5, 5.14, 0.00, 0.18, 1.02, 19.34, 0.00],
                [5, 5.76, 0.00, 0.08, 1.12, 16.11, 0.00],
                [5, 5.27, 0.00, 0.10, 1.14, 0.62, 0.00],
                [5, 5.54, 0.00, 0.03, 0.89, 9.98, 0.00],
                [5, 5.50, 0.00, 0.00, 0.83, 0.62, 0.00],
                [5, 5.59, 0.00, 0.03, 1.05, 21.17, 0.00],
                [5, 5.08, 0.00, 0.13, 1.10, 4.86, 0.00],
                [5, 5.16, 0.00, 0.04, 1.05, 12.51, 0.00],
                [5, 4.06, 0.00, 0.33, 1.13, 11.34, 0.00],
                [5, 4.81, 0.00, 0.04, 1.07, 19.60, 0.00],
                [5, 5.11, 0.00, 0.11, 1.08, 20.49, 0.00],
                [5, 5.39, 0.00, 0.13, 0.99, 16.62, 0.00],
                [5, 5.66, 0.00, 0.14, 1.13, 16.32, 0.00],
                [5, 5.79, 0.00, 0.11, 1.01, 13.13, 0.00],
                [5, 5.02, 0.00, 0.16, 1.11, 22.10, 0.00],
                [5, 6.01, 0.00, 0.20, 1.12, 1.79, 0.00],
                [5, 5.60, 0.00, 0.02, 1.14, 9.31, 0.00],
                [5, 4.87, 0.00, 0.21, 0.83, 14.58, 0.00],
                [5, 5.73, 0.00, 0.13, 1.08, 21.77, 0.00],
                [5, 5.24, 0.00, 0.07, 1.15, 11.20, 0.00],
                [5, 5.35, 0.00, 0.00, 1.07, 12.13, 0.00],
                [5, 5.53, 0.00, 0.05, 1.03, 30.05, 0.00],
                [5, 4.84, 0.00, 0.17, 1.04, 19.68, 0.00],
                [5, 5.53, 0.00, 0.11, 1.07, 15.41, 0.00],
                [5, 5.06, 0.00, 0.08, 0.89, 23.06, 0.00],
                [5, 5.85, 0.00, 0.18, 1.03, 7.39, 0.00],
                [5, 5.79, 0.00, 0.08, 1.08, 25.23, 0.00],
                [5, 5.32, 0.00, 0.09, 1.13, 18.91, 0.00],
                [5, 5.67, 0.00, 0.05, 1.02, 13.96, 0.00],
                [5, 5.97, 0.00, 0.11, 1.18, 15.44, 0.00],
                [5, 5.66, 0.00, 0.03, 1.04, 13.26, 0.00],
                [5, 5.25, 0.00, 0.13, 1.10, 7.98, 0.00],
                [5, 5.30, 0.00, 0.05, 0.78, 16.66, 0.00],
                [5, 0.00, 0.00, 1.50, 1.08, 7.61, 0.00],
                [5, 5.34, 0.00, 0.73, 1.16, 23.67, 0.00],
                [5, 5.04, 0.00, 0.28, 1.13, 2.93, 0.00],
                [5, 6.44, 0.00, 0.53, 1.03, 3.85, 0.00],
                [5, 5.13, 0.00, 0.10, 1.17, 2.14, 0.00],
                [5, 5.45, 0.00, 0.04, 1.03, 19.89, 0.00],
                [5, 6.49, 0.00, 0.31, 1.10, 2.15, 0.00],
                [5, 7.02, 0.00, 0.30, 2.19, 36.18, 0.00],
                [5, 5.26, 0.00, 0.34, 1.21, 23.22, 0.00],
                [5, 5.65, 0.00, 0.06, 1.15, 5.40, 0.00],
                [5, 5.54, 0.00, 0.06, 0.94, 15.75, 0.00],
                [5, 0.00, 0.00, 1.57, 1.08, 7.31, 0.00],
                [5, 5.14, 0.00, 0.64, 0.94, 7.89, 0.00],
                [5, 6.09, 0.00, 0.58, 0.96, 29.31, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 281016551'
            },
            series: [{
              data:
              [
                [6, 0.00, 0.00, 2.07, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 1.03, 2.59, 123.09, 1.00],
                [6, 0.00, 0.00, 0.52, 1.99, 122.83, 1.00],
                [6, 0.00, 0.00, 0.26, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.13, 1.99, 0.38, 0.00],
                [6, 1.95, 0.00, 0.48, 2.59, 123.63, 1.00],
                [6, 0.00, 0.00, 0.30, 2.59, 1.89, 0.00],
                [6, 0.00, 0.00, 0.15, 1.99, 123.09, 1.00],
                [6, 0.99, 0.00, 0.20, 2.59, 124.20, 1.00],
                [6, 0.00, 0.00, 0.18, 1.99, 123.93, 1.00],
                [6, 0.00, 0.00, 0.09, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.04, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.02, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.01, 2.58, 157.54, 1.00],
                [6, 0.00, 0.00, 0.01, 1.99, 157.54, 1.00],
                [6, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [6, 23.67, 0.00, 6.57, 2.78, 113.97, 1.00],
                [6, 0.00, 0.00, 3.29, 1.99, 114.30, 0.00],
                [6, 0.00, 0.00, 1.64, 2.59, 124.49, 1.00],
                [6, 0.00, 0.00, 0.82, 1.99, 124.22, 1.00],
                [6, 0.00, 0.00, 0.41, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.21, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.10, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.05, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.03, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.00, 2.58, 157.07, 1.00],
                [6, 0.00, 0.00, 0.00, 1.99, 157.26, 1.00],
                [6, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [6, 24.73, 0.00, 6.87, 2.51, 93.05, 1.00],
                [6, 0.00, 0.00, 3.44, 1.99, 92.69, 0.00],
                [6, 0.00, 0.00, 1.72, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.86, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.43, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.21, 2.58, 157.54, 1.00],
                [6, 0.00, 0.00, 0.11, 1.99, 157.36, 1.00],
                [6, 0.00, 0.00, 0.05, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.03, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.01, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.01, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [6, 0.00, 0.00, 0.00, 2.59, 124.49, 1.00],
                [6, 0.00, 0.00, 0.00, 1.99, 124.22, 1.00],
                [6, 0.00, 0.00, 0.00, 2.58, 157.36, 1.00],
                [6, 0.00, 0.00, 0.00, 1.99, 157.54, 1.00],
                [6, 3.44, 0.00, 0.96, 2.59, 124.49, 1.00],
                [6, 0.00, 0.00, 0.48, 1.99, 124.22, 1.00],
                [6, 0.00, 0.00, 0.24, 2.58, 157.36, 1.00],
                [6, 0.00, 0.00, 0.12, 2.58, 0.44, 0.00],
                [6, 0.00, 0.00, 0.06, 1.99, 157.26, 1.00],
                [6, 0.00, 0.00, 0.03, 2.59, 123.09, 1.00],
                [6, 0.00, 0.00, 0.01, 1.99, 123.09, 1.00],
                [6, 4.22, 0.00, 1.17, 2.59, 127.97, 1.00],
                [6, 0.00, 0.00, 0.59, 2.59, 10.87, 0.00],
                [6, 20.70, 0.00, 5.46, 3.03, 42.34, 1.00],
                [6, 0.00, 0.00, 3.02, 2.59, 42.34, 0.00],
                [6, 0.00, 0.00, 1.51, 1.99, 123.09, 1.00],
                [6, 23.25, 0.00, 5.70, 2.98, 144.40, 2.00],
                [6, 0.00, 0.00, 3.61, 1.99, 144.40, 1.00],
                [6, 0.00, 0.00, 1.80, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.90, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.45, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.23, 1.99, 0.00, 0.00],
                [6, 0.00, 0.00, 0.11, 2.59, 124.49, 1.00],
                [6, 10.68, 0.00, 2.91, 2.14, 121.24, 1.00],
                [6, 0.00, 0.00, 1.51, 1.99, 3.88, 0.00],
                [6, 0.00, 0.00, 0.76, 2.59, 123.09, 1.00],
                [6, 0.00, 0.00, 0.38, 1.99, 123.09, 1.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 281218691'
            },
            series: [{
              data:
              [
                [7, 0.00, 0.00, 0.00, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 2.58, 0.00, 0.00],
                [7, 9.89, 0.00, 2.75, 2.59, 26.62, 0.00],
                [7, 0.00, 0.00, 1.37, 2.58, 26.62, 0.00],
                [7, 0.00, 0.00, 0.69, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.34, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.17, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.09, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.04, 2.58, 0.00, 0.00],
                [7, 12.03, 0.00, 3.32, 2.59, 22.98, 0.00],
                [7, 13.74, 0.00, 2.13, 2.55, 9.81, 0.00],
                [7, 0.00, 0.00, 2.75, 2.58, 13.18, 0.00],
                [7, 0.00, 0.00, 1.37, 2.58, 0.00, 0.00],
                [7, 10.58, 0.00, 2.25, 2.59, 25.49, 0.00],
                [7, 0.00, 0.00, 1.81, 2.58, 25.49, 0.00],
                [7, 0.00, 0.00, 0.91, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.45, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.23, 2.58, 0.00, 0.00],
                [7, 0.00, 0.00, 0.11, 1.99, 157.36, 1.00],
                [7, 0.00, 0.00, 0.06, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.03, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.01, 2.58, 157.54, 1.00],
                [7, 0.00, 0.00, 0.01, 1.99, 157.54, 1.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 23.06, 0.00, 6.40, 2.02, 25.78, 1.00],
                [7, 0.00, 0.00, 3.20, 1.99, 25.78, 0.00],
                [7, 0.00, 0.00, 1.60, 2.58, 157.54, 1.00],
                [7, 0.00, 0.00, 0.80, 1.99, 157.54, 1.00],
                [7, 0.00, 0.00, 0.40, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.20, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.10, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.05, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.03, 1.99, 0.38, 0.00],
                [7, 19.05, 0.00, 5.28, 2.09, 14.65, 1.00],
                [7, 0.00, 0.00, 2.65, 1.99, 15.00, 0.00],
                [7, 17.50, 0.00, 3.53, 3.01, 153.27, 1.00],
                [7, 0.00, 0.00, 3.09, 1.99, 153.08, 1.00],
                [7, 0.00, 0.00, 1.55, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.77, 2.59, 123.09, 1.00],
                [7, 0.00, 0.00, 0.39, 2.59, 0.00, 0.00],
                [7, 0.00, 0.00, 0.19, 1.99, 123.09, 1.00],
                [7, 0.00, 0.00, 0.10, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.05, 2.58, 157.36, 1.00],
                [7, 0.00, 0.00, 0.02, 1.99, 157.36, 1.00],
                [7, 0.00, 0.00, 0.01, 2.58, 157.36, 1.00],
                [7, 0.00, 0.00, 0.01, 1.99, 157.54, 1.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 22.14, 0.00, 6.15, 1.98, 55.24, 1.00],
                [7, 0.00, 0.00, 3.08, 1.99, 55.24, 0.00],
                [7, 0.00, 0.00, 1.54, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.77, 2.58, 157.54, 1.00],
                [7, 0.00, 0.00, 0.38, 1.99, 157.54, 1.00],
                [7, 0.00, 0.00, 0.19, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.10, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.05, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.02, 2.59, 124.22, 1.00],
                [7, 0.00, 0.00, 0.01, 2.58, 46.97, 0.00],
                [7, 0.00, 0.00, 0.01, 1.99, 157.07, 1.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 2.59, 123.09, 1.00],
                [7, 0.00, 0.00, 0.00, 1.99, 123.09, 1.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.00, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 0.00, 0.00, 0.00, 1.99, 0.38, 0.00],
                [7, 23.79, 0.00, 6.61, 3.09, 109.16, 1.00],
                [7, 0.00, 0.00, 3.30, 1.99, 109.50, 0.00],
                [7, 0.00, 0.00, 1.65, 2.59, 123.09, 1.00],
                [7, 0.00, 0.00, 0.83, 1.99, 123.09, 1.00],
                [7, 23.33, 0.00, 6.07, 2.90, 140.88, 2.00],
                [7, 0.00, 0.00, 3.45, 1.99, 140.88, 1.00],
                [7, 22.95, 0.00, 4.65, 2.63, 116.52, 1.00],
                [7, 0.00, 0.00, 4.05, 2.58, 72.95, 1.00],
                [7, 0.00, 0.00, 2.02, 1.99, 157.36, 1.00],
                [7, 1.38, 0.00, 0.63, 2.59, 123.85, 1.00],
                [7, 0.00, 0.00, 0.70, 1.99, 124.11, 1.00],
                [7, 0.00, 0.00, 0.35, 2.59, 123.09, 1.00],
                [7, 23.42, 0.00, 6.33, 2.96, 35.00, 1.00],
                [7, 0.00, 0.00, 3.34, 2.58, 15.83, 0.00],
                [7, 0.00, 0.00, 1.67, 1.99, 157.07, 1.00],
                [7, 0.00, 0.00, 0.84, 1.99, 0.38, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 285415814'
            },
            series: [{
              data:
              [
                [8, 0.00, 0.00, 0.05, 1.96, 0.00, 0.00],
                [8, 0.00, 0.00, 0.03, 2.01, 0.33, 0.00],
                [8, 0.00, 0.00, 0.01, 2.01, 0.33, 0.00],
                [8, 0.00, 0.00, 0.01, 1.93, 6.34, 0.00],
                [8, 0.00, 0.00, 0.00, 2.01, 6.34, 0.00],
                [8, 0.00, 0.00, 0.00, 1.96, 0.00, 0.00],
                [8, 2.70, 0.00, 0.75, 2.01, 0.08, 0.00],
                [8, 16.53, 0.00, 4.22, 2.00, 9.43, 1.00],
                [8, 0.00, 0.00, 2.48, 2.01, 9.38, 0.00],
                [8, 23.31, 0.00, 5.23, 1.96, 75.80, 1.00],
                [8, 0.00, 0.00, 3.86, 1.93, 75.06, 0.00],
                [8, 0.00, 0.00, 1.93, 1.96, 0.74, 0.00],
                [8, 0.00, 0.00, 0.96, 2.01, 0.33, 0.00],
                [8, 0.00, 0.00, 0.48, 1.93, 0.43, 0.00],
                [8, 0.00, 0.00, 0.24, 1.96, 0.74, 0.00],
                [8, 1.43, 0.00, 0.28, 1.93, 0.71, 0.00],
                [8, 0.00, 0.00, 0.26, 1.96, 0.71, 0.00],
                [8, 2.53, 0.00, 0.57, 2.01, 0.10, 0.00],
                [8, 0.00, 0.00, 0.42, 2.01, 0.24, 0.00],
                [8, 0.00, 0.00, 0.21, 1.96, 0.33, 0.00],
                [8, 23.00, 0.00, 6.28, 1.90, 84.62, 1.00],
                [8, 0.00, 0.00, 3.25, 2.01, 84.29, 0.00],
                [8, 0.00, 0.00, 1.62, 2.01, 0.00, 0.00],
                [8, 0.00, 0.00, 0.81, 2.01, 0.33, 0.00],
                [8, 0.00, 0.00, 0.41, 2.01, 0.00, 0.00],
                [8, 0.00, 0.00, 0.20, 2.01, 0.00, 0.00],
                [8, 0.00, 0.00, 0.10, 2.01, 0.33, 0.00],
                [8, 0.00, 0.00, 0.05, 1.96, 0.33, 0.00],
                [8, 19.85, 0.00, 5.49, 1.99, 14.40, 1.00],
                [8, 0.00, 0.00, 2.77, 1.96, 14.40, 0.00],
                [8, 0.00, 0.00, 1.39, 2.01, 0.00, 0.00],
                [8, 0.00, 0.00, 0.69, 1.93, 0.91, 0.00],
                [8, 7.21, 0.00, 1.66, 2.01, 4.10, 0.00],
                [8, 22.24, 0.00, 5.00, 1.98, 24.36, 1.00],
                [8, 2.74, 0.00, 2.91, 2.01, 19.89, 0.00],
                [8, 1.89, 0.00, 1.69, 1.93, 2.01, 0.00],
                [8, 0.00, 0.00, 1.37, 2.01, 1.18, 0.00],
                [8, 20.38, 0.00, 4.98, 1.99, 15.20, 1.00],
                [8, 0.00, 0.00, 3.17, 2.01, 15.53, 0.00],
                [8, 3.19, 0.00, 0.70, 1.93, 4.70, 0.00],
                [8, 0.00, 0.00, 1.24, 2.01, 4.70, 0.00],
                [8, 0.00, 0.00, 0.62, 1.93, 0.12, 0.00],
                [8, 0.00, 0.00, 0.31, 1.96, 0.12, 0.00],
                [8, 2.29, 0.00, 0.48, 2.01, 0.52, 0.00],
                [8, 0.00, 0.00, 0.39, 1.96, 0.52, 0.00],
                [8, 0.00, 0.00, 0.20, 2.01, 0.00, 0.00],
                [8, 3.02, 0.00, 0.74, 1.93, 2.65, 0.00],
                [8, 0.00, 0.00, 0.47, 2.01, 2.75, 0.00],
                [8, 0.00, 0.00, 0.23, 2.01, 0.00, 0.00],
                [8, 0.00, 0.00, 0.12, 1.96, 0.33, 0.00],
                [8, 0.00, 0.00, 0.06, 2.01, 0.00, 0.00],
                [8, 8.79, 0.00, 2.41, 1.93, 0.23, 0.00],
                [8, 0.00, 0.00, 1.24, 1.96, 0.23, 0.00],
                [8, 2.23, 0.00, 0.00, 1.93, 6.04, 0.00],
                [8, 0.00, 0.00, 0.62, 2.01, 6.04, 0.00],
                [8, 0.00, 0.00, 0.31, 2.01, 0.00, 0.00],
                [8, 0.00, 0.00, 0.15, 2.01, 0.00, 0.00],
                [8, 2.47, 0.00, 0.61, 2.01, 0.23, 0.00],
                [8, 0.00, 0.00, 0.38, 2.01, 0.11, 0.00],
                [8, 0.00, 0.00, 0.19, 1.96, 0.33, 0.00],
                [8, 0.00, 0.00, 0.10, 2.01, 0.33, 0.00],
                [8, 23.44, 0.00, 6.46, 1.97, 45.67, 1.00],
                [8, 0.00, 0.00, 3.28, 2.01, 45.78, 0.00],
                [8, 0.00, 0.00, 1.64, 1.96, 0.22, 0.00],
                [8, 0.00, 0.00, 0.82, 2.01, 0.33, 0.00],
                [8, 3.13, 0.00, 0.46, 1.93, 2.91, 0.00],
                [8, 21.97, 0.00, 5.46, 1.98, 21.34, 1.00],
                [8, 0.00, 0.00, 3.37, 2.01, 19.95, 0.00],
                [8, 0.00, 0.00, 1.69, 1.96, 0.33, 0.00],
                [8, 0.00, 0.00, 0.84, 2.01, 0.33, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 309664197'
            },
            series: [{
              data:
              [
                [9, 0.00, 0.00, 0.00, 2.59, 132.81, 1.00],
                [9, 0.00, 0.00, 0.00, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 0.00, 2.57, 265.37, 1.00],
                [9, 36.86, 0.00, 10.24, 2.60, 121.50, 2.00],
                [9, 2.41, 0.00, 4.45, 2.56, 127.82, 2.00],
                [9, 3.63, 0.00, 1.89, 2.58, 4.36, 0.00],
                [9, 15.37, 0.00, 2.32, 2.55, 278.40, 1.00],
                [9, 0.00, 0.00, 3.11, 2.59, 11.07, 0.00],
                [9, 0.00, 0.00, 1.55, 2.59, 0.00, 0.00],
                [9, 35.19, 0.00, 9.00, 2.59, 157.61, 2.00],
                [9, 0.00, 0.00, 5.28, 2.59, 114.80, 1.00],
                [9, 0.86, 0.00, 2.40, 2.59, 2.37, 0.00],
                [9, 0.00, 0.00, 1.44, 2.59, 2.37, 0.00],
                [9, 0.00, 0.00, 0.72, 2.59, 272.40, 1.00],
                [9, 42.63, 0.00, 11.48, 2.62, 98.01, 1.00],
                [9, 20.56, 0.00, 0.39, 2.57, 195.78, 1.00],
                [9, 0.00, 0.00, 5.91, 2.59, 293.78, 2.00],
                [9, 0.00, 0.00, 2.95, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 1.48, 2.59, 0.00, 0.00],
                [9, 20.18, 0.00, 4.87, 2.53, 23.25, 1.00],
                [9, 8.48, 0.00, 0.82, 2.56, 19.85, 0.00],
                [9, 0.00, 0.00, 2.76, 2.59, 3.40, 0.00],
                [9, 29.33, 0.00, 6.77, 2.56, 234.66, 2.00],
                [9, 33.64, 0.00, 4.58, 2.54, 296.14, 2.00],
                [9, 0.00, 0.00, 7.05, 2.59, 61.56, 1.00],
                [9, 0.00, 0.00, 3.53, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 1.76, 2.59, 272.40, 1.00],
                [9, 0.00, 0.00, 0.88, 2.59, 0.00, 0.00],
                [9, 35.14, 0.00, 9.32, 2.59, 112.87, 1.00],
                [9, 36.64, 0.00, 5.08, 2.59, 33.96, 1.00],
                [9, 30.40, 0.00, 0.81, 2.57, 36.14, 0.00],
                [9, 0.00, 0.00, 8.04, 2.59, 229.63, 2.00],
                [9, 0.00, 0.00, 4.02, 2.59, 272.40, 2.00],
                [9, 42.85, 0.00, 9.89, 2.62, 172.05, 2.00],
                [9, 10.96, 0.00, 3.91, 2.58, 158.46, 1.00],
                [9, 0.00, 0.00, 5.00, 2.59, 13.59, 1.00],
                [9, 33.22, 0.00, 6.73, 2.54, 331.97, 2.00],
                [9, 0.00, 0.00, 5.86, 2.56, 331.97, 2.00],
                [9, 0.00, 0.00, 2.93, 2.56, 0.00, 0.00],
                [9, 13.26, 0.00, 2.22, 2.55, 280.24, 1.00],
                [9, 26.96, 0.00, 4.92, 2.56, 36.98, 1.00],
                [9, 6.66, 0.00, 3.18, 2.60, 25.42, 0.00],
                [9, 0.00, 0.00, 3.44, 2.59, 3.72, 0.00],
                [9, 0.00, 0.00, 1.72, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 0.86, 2.56, 272.40, 1.00],
                [9, 0.00, 0.00, 0.43, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 0.22, 2.59, 272.40, 1.00],
                [9, 40.22, 0.00, 11.06, 2.62, 74.12, 1.00],
                [9, 0.00, 0.00, 5.64, 2.56, 198.28, 2.00],
                [9, 0.00, 0.00, 2.82, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 1.41, 2.59, 272.40, 1.00],
                [9, 0.00, 0.00, 0.70, 2.59, 0.00, 0.00],
                [9, 24.45, 0.00, 6.44, 2.57, 245.69, 2.00],
                [9, 37.30, 0.00, 6.79, 2.60, 103.88, 1.00],
                [9, 0.00, 0.00, 6.97, 2.59, 130.59, 2.00],
                [9, 11.71, 0.00, 0.23, 2.61, 267.94, 1.00],
                [9, 0.00, 0.00, 3.37, 2.56, 267.94, 1.00],
                [9, 0.00, 0.00, 1.68, 2.59, 272.40, 1.00],
                [9, 23.13, 0.00, 5.58, 2.57, 297.28, 2.00],
                [9, 0.00, 0.00, 3.63, 2.59, 297.28, 1.00],
                [9, 0.00, 0.00, 1.82, 2.56, 272.40, 1.00],
                [9, 0.00, 0.00, 0.91, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 0.45, 2.59, 272.40, 1.00],
                [9, 0.00, 0.00, 0.23, 2.59, 0.00, 0.00],
                [9, 0.00, 0.00, 0.11, 2.56, 272.40, 1.00],
                [9, 3.30, 0.00, 0.86, 2.57, 5.47, 0.00],
                [9, 0.00, 0.00, 0.49, 2.59, 5.47, 0.00],
                [9, 18.84, 0.00, 4.99, 2.58, 20.48, 1.00],
                [9, 16.35, 0.00, 1.80, 2.57, 29.41, 0.00],
                [9, 0.00, 0.00, 3.64, 2.59, 281.32, 1.00],
                [9, 32.74, 0.00, 7.27, 2.54, 57.77, 1.00],
                [9, 0.00, 0.00, 5.46, 2.59, 57.77, 1.00],
                [9, 0.00, 0.00, 2.73, 2.59, 0.00, 0.00],
                [9, 30.63, 0.00, 7.14, 2.58, 37.24, 1.00],
                [9, 23.48, 0.00, 1.59, 2.56, 13.72, 0.00],
                [9, 0.00, 0.00, 5.73, 2.59, 248.88, 2.00],
                [9, 0.00, 0.00, 2.86, 2.59, 272.40, 1.00],
                [9, 0.00, 0.00, 1.43, 2.59, 272.40, 1.00],
                [9, 8.46, 0.00, 1.63, 2.58, 11.37, 0.00],
                [9, 0.00, 0.00, 1.53, 2.59, 261.02, 1.00],
                [9, 0.00, 0.00, 0.77, 2.59, 0.00, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 288798709'
            },
            series: [{
              data:
              [
                [10, 48.46, 0.00, 7.35, 2.58, 167.78, 2.00],
                [10, 13.74, 0.00, 5.97, 2.58, 218.31, 2.00],
                [10, 22.52, 0.00, 0.55, 2.58, 252.13, 1.00],
                [10, 0.00, 0.00, 6.53, 2.59, 9.59, 1.00],
                [10, 0.00, 0.00, 3.26, 2.59, 279.03, 1.00],
                [10, 28.29, 0.00, 6.23, 2.56, 21.78, 1.00],
                [10, 7.70, 0.00, 2.61, 2.58, 303.90, 1.00],
                [10, 16.53, 0.00, 1.15, 2.61, 10.16, 0.00],
                [10, 0.00, 0.00, 4.02, 2.59, 13.26, 1.00],
                [10, 0.00, 0.00, 2.01, 2.59, 279.03, 1.00],
                [10, 0.00, 0.00, 1.00, 2.59, 0.00, 0.00],
                [10, 19.62, 0.00, 4.95, 2.55, 31.00, 1.00],
                [10, 0.00, 0.00, 2.98, 2.59, 31.00, 0.00],
                [10, 0.00, 0.00, 1.49, 2.59, 0.00, 0.00],
                [10, 37.48, 0.00, 9.67, 2.50, 66.14, 1.00],
                [10, 0.00, 0.00, 5.58, 2.59, 346.11, 2.00],
                [10, 0.00, 0.00, 2.79, 2.59, 280.06, 1.00],
                [10, 0.00, 0.00, 1.39, 2.59, 0.00, 0.00],
                [10, 0.00, 0.00, 0.70, 2.59, 0.00, 0.00],
                [10, 0.00, 0.00, 0.35, 2.59, 280.06, 1.00],
                [10, 4.61, 0.00, 1.11, 2.59, 1.03, 0.00],
                [10, 0.00, 0.00, 0.73, 2.59, 279.03, 1.00],
                [10, 0.00, 0.00, 0.36, 2.59, 0.00, 0.00],
                [10, 0.00, 0.00, 0.18, 2.59, 0.00, 0.00],
                [10, 0.00, 0.00, 0.09, 2.59, 280.06, 1.00],
                [10, 17.22, 0.00, 4.74, 2.61, 13.16, 1.00],
                [10, 0.00, 0.00, 2.41, 2.59, 14.19, 0.00],
                [10, 0.00, 0.00, 1.21, 2.59, 0.00, 0.00],
                [10, 0.00, 0.00, 0.60, 2.59, 279.03, 1.00],
                [10, 0.00, 0.00, 0.30, 2.59, 280.06, 1.00],
                [10, 53.50, 0.00, 14.71, 2.59, 69.42, 2.00],
                [10, 28.87, 0.00, 0.51, 2.60, 153.63, 1.00],
                [10, 0.00, 0.00, 7.76, 2.59, 223.04, 2.00],
                [10, 37.34, 0.00, 6.49, 2.65, 184.68, 2.00],
                [10, 10.90, 0.00, 4.10, 2.58, 97.78, 1.00],
                [10, 0.00, 0.00, 5.08, 2.59, 282.46, 2.00],
                [10, 0.00, 0.00, 2.54, 2.59, 280.06, 1.00],
                [10, 6.75, 0.00, 0.60, 2.58, 281.65, 1.00],
                [10, 29.90, 0.00, 6.73, 2.55, 306.75, 2.00],
                [10, 0.00, 0.00, 4.94, 2.59, 304.13, 2.00],
                [10, 0.00, 0.00, 2.47, 2.59, 279.03, 1.00],
                [10, 5.72, 0.00, 0.35, 2.59, 1.65, 0.00],
                [10, 0.00, 0.00, 1.41, 2.59, 1.65, 0.00],
                [10, 0.00, 0.00, 0.71, 2.59, 0.00, 0.00],
                [10, 17.49, 0.00, 4.51, 2.56, 26.86, 1.00],
                [10, 0.00, 0.00, 2.61, 2.59, 252.18, 1.00],
                [10, 53.82, 0.00, 13.65, 2.59, 74.35, 2.00],
                [10, 12.48, 0.00, 4.66, 2.57, 195.20, 2.00],
                [10, 0.00, 0.00, 5.80, 2.59, 270.57, 2.00],
                [10, 5.43, 0.00, 1.39, 2.58, 280.19, 1.00],
                [10, 0.00, 0.00, 2.20, 2.59, 279.16, 1.00],
                [10, 53.41, 0.00, 13.73, 2.59, 66.91, 2.00],
                [10, 0.00, 0.00, 7.97, 2.59, 212.12, 2.00],
                [10, 15.46, 0.00, 0.31, 2.57, 5.38, 0.00],
                [10, 13.66, 0.00, 0.34, 2.58, 17.93, 0.00],
                [10, 0.00, 0.00, 3.97, 2.59, 266.47, 1.00],
                [10, 0.00, 0.00, 1.98, 2.59, 0.00, 0.00],
                [10, 1.25, 0.00, 0.64, 2.59, 0.85, 0.00],
                [10, 14.64, 0.00, 3.40, 2.56, 258.17, 1.00],
                [10, 41.30, 0.00, 9.10, 2.64, 88.86, 1.00],
                [10, 0.00, 0.00, 6.92, 2.59, 168.47, 2.00],
                [10, 34.23, 0.00, 6.05, 2.53, 318.74, 2.00],
                [10, 26.09, 0.00, 0.76, 2.60, 86.04, 0.00],
                [10, 52.80, 0.00, 7.80, 2.59, 171.81, 3.00],
                [10, 0.00, 0.00, 10.77, 2.59, 218.10, 2.00],
                [10, 38.63, 0.00, 5.35, 2.65, 99.48, 1.00],
                [10, 0.00, 0.00, 8.06, 2.59, 180.57, 2.00],
                [10, 0.00, 0.00, 4.03, 2.59, 0.00, 1.00],
                [10, 26.53, 0.00, 5.36, 2.60, 232.30, 2.00],
                [10, 0.00, 0.00, 4.69, 2.59, 47.77, 1.00],
                [10, 0.00, 0.00, 2.35, 2.59, 280.06, 1.00],
            ]
          }]
          },
          {
            title: {
                text:  '车辆驾驶画像可视分析——ID: 309510952'
            },
            series: [{
              data:
              [
                [11, 0.00, 0.00, 6.58, 2.59, 141.32, 2.00],
                [11, 42.75, 0.00, 8.59, 2.62, 181.68, 2.00],
                [11, 0.00, 0.00, 7.58, 2.59, 90.72, 1.00],
                [11, 0.00, 0.00, 3.79, 2.59, 272.40, 1.00],
                [11, 0.00, 0.00, 1.90, 2.59, 0.00, 0.00],
                [11, 0.00, 0.00, 0.95, 2.59, 272.40, 1.00],
                [11, 42.51, 0.00, 11.33, 2.62, 95.64, 1.00],
                [11, 28.74, 0.00, 1.84, 2.53, 141.31, 1.00],
                [11, 35.13, 0.00, 2.70, 2.59, 207.12, 1.00],
                [11, 0.00, 0.00, 8.41, 2.59, 110.94, 1.00],
                [11, 0.00, 0.00, 4.21, 2.59, 0.00, 1.00],
                [11, 0.00, 0.00, 2.10, 2.59, 272.40, 1.00],
                [11, 0.00, 0.00, 1.05, 2.59, 0.00, 0.00],
                [11, 0.00, 0.00, 0.53, 2.59, 0.00, 0.00],
                [11, 31.24, 0.00, 8.42, 2.58, 225.40, 2.00],
                [11, 0.00, 0.00, 4.47, 2.59, 47.01, 1.00],
                [11, 0.00, 0.00, 2.24, 2.59, 272.40, 1.00],
                [11, 0.00, 0.00, 1.12, 2.56, 272.40, 1.00],
                [11, 0.00, 0.00, 0.56, 2.56, 0.00, 0.00],
                [11, 0.00, 0.00, 0.28, 2.59, 272.40, 1.00],
                [11, 0.00, 0.00, 0.14, 2.59, 0.00, 0.00],
                [11, 35.42, 0.00, 9.77, 2.60, 207.77, 2.00],
                [11, 42.40, 0.00, 6.82, 2.62, 124.43, 2.00],
                [11, 3.56, 0.00, 7.38, 2.57, 181.11, 2.00],
                [11, 1.69, 0.00, 4.21, 2.57, 1.29, 1.00],
                [11, 43.16, 0.00, 9.42, 2.61, 153.75, 2.00],
                [11, 0.00, 0.00, 7.28, 2.59, 112.01, 1.00],
                [11, 0.00, 0.00, 3.64, 2.59, 272.40, 1.00],
                [11, 0.00, 0.00, 1.82, 2.59, 272.40, 1.00],
                [11, 36.60, 0.00, 9.26, 2.59, 187.37, 2.00],
                [11, 9.06, 0.00, 3.02, 2.58, 73.14, 0.00],
                [11, 0.00, 0.00, 4.03, 2.59, 11.90, 1.00],
                [11, 0.00, 0.00, 2.01, 2.56, 0.00, 0.00],
                [11, 11.30, 0.00, 2.13, 2.56, 278.08, 1.00],
                [11, 28.33, 0.00, 5.80, 2.56, 243.66, 2.00],
                [11, 0.00, 0.00, 4.97, 2.59, 237.98, 2.00],
                [11, 33.61, 0.00, 6.85, 2.60, 215.61, 2.00],
                [11, 0.00, 0.00, 5.91, 2.59, 215.61, 2.00],
                [11, 0.00, 0.00, 2.96, 2.59, 272.40, 1.00],
                [11, 32.23, 0.00, 7.48, 2.54, 328.26, 2.00],
                [11, 0.00, 0.00, 5.22, 2.59, 55.93, 1.00],
                [11, 32.04, 0.00, 6.29, 2.59, 42.58, 1.00],
                [11, 31.97, 0.00, 3.13, 2.59, 179.38, 1.00],
                [11, 7.79, 0.00, 5.15, 2.56, 224.90, 2.00],
                [11, 13.83, 0.00, 0.90, 2.55, 5.67, 0.00],
                [11, 9.67, 0.00, 1.61, 2.58, 268.57, 1.00],
                [11, 0.00, 0.00, 3.49, 2.59, 12.44, 0.00],
                [11, 0.00, 0.00, 1.74, 2.59, 0.00, 0.00],
                [11, 0.00, 0.00, 0.87, 2.59, 272.40, 1.00],
                [11, 17.72, 0.00, 4.49, 2.58, 252.94, 2.00],
                [11, 19.21, 0.00, 2.66, 2.53, 272.85, 1.00],
                [11, 0.00, 0.00, 4.01, 2.59, 292.31, 2.00],
                [11, 0.00, 0.00, 2.00, 2.59, 272.40, 1.00],
                [11, 0.00, 0.00, 1.00, 2.59, 272.40, 1.00],
                [11, 37.79, 0.00, 10.00, 2.60, 132.68, 2.00],
                [11, 0.00, 0.00, 5.50, 2.59, 132.68, 2.00],
                [11, 7.12, 0.00, 0.77, 2.57, 274.94, 1.00],
                [11, 26.12, 0.00, 4.89, 2.53, 37.02, 1.00],
                [11, 0.00, 0.00, 4.81, 2.59, 311.91, 2.00],
                [11, 0.00, 0.00, 2.40, 2.56, 0.00, 0.00],
                [11, 16.51, 0.00, 3.38, 2.60, 263.50, 1.00],
                [11, 0.00, 0.00, 2.89, 2.59, 8.90, 0.00],
                [11, 25.50, 0.00, 5.64, 2.53, 38.11, 1.00],
                [11, 0.00, 0.00, 4.26, 2.59, 310.47, 2.00],
                [11, 20.81, 0.00, 3.65, 2.53, 297.90, 1.00],
                [11, 22.32, 0.00, 2.24, 2.53, 4.73, 0.00],
                [11, 35.53, 0.00, 4.79, 2.61, 87.70, 1.00],
                [11, 3.30, 0.00, 6.56, 2.56, 212.97, 2.00],
                [11, 0.00, 0.00, 4.20, 2.59, 270.41, 2.00],
                [11, 1.09, 0.00, 1.80, 2.59, 3.26, 0.00],
                [11, 15.56, 0.00, 3.12, 2.58, 251.48, 1.00],
                [11, 0.00, 0.00, 2.76, 2.59, 254.74, 1.00],
                [11, 33.66, 0.00, 7.97, 2.54, 79.05, 1.00],
                [11, 0.00, 0.00, 5.36, 2.59, 79.05, 1.00],
                [11, 0.00, 0.00, 2.68, 2.59, 272.40, 1.00],
                [11, 33.73, 0.00, 8.03, 2.60, 222.52, 2.00],
                [11, 17.09, 0.00, 0.61, 2.57, 233.41, 1.00],
                [11, 0.00, 0.00, 5.05, 2.59, 10.90, 1.00],
                [11, 5.37, 0.00, 1.03, 2.57, 9.09, 0.00],
                [11, 0.00, 0.00, 2.01, 2.59, 9.09, 0.00],
                [11, 13.03, 0.00, 2.62, 2.57, 4.71, 0.00],
            ]
          }]
          },
          {
            title: {
                text: '车辆驾驶画像可视分析——ID: 310106373'
            },
            series: [{
              data:
              [
                [12, 0.00, 0.00, 0.00, 2.59, 223.04, 1.00],
                [12, 0.00, 0.00, 0.00, 2.59, 0.00, 0.00],
                [12, 28.25, 0.00, 7.85, 2.60, 226.23, 2.00],
                [12, 0.00, 0.00, 3.92, 2.59, 53.83, 0.00],
                [12, 2.21, 0.00, 1.35, 2.59, 1.01, 0.00],
                [12, 0.00, 0.00, 1.29, 2.59, 279.05, 1.00],
                [12, 0.00, 0.00, 0.64, 2.59, 1.03, 0.00],
                [12, 0.00, 0.00, 0.32, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 0.16, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 0.08, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 0.04, 2.59, 279.03, 1.00],
                [12, 37.99, 0.00, 10.53, 2.65, 181.61, 2.00],
                [12, 53.92, 0.00, 9.69, 2.59, 104.29, 2.00],
                [12, 0.00, 0.00, 10.13, 2.59, 77.33, 1.00],
                [12, 0.00, 0.00, 5.07, 2.59, 279.03, 2.00],
                [12, 0.00, 0.00, 2.53, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 1.27, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 0.63, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 0.32, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 0.16, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 0.08, 2.59, 1.03, 0.00],
                [12, 27.84, 0.00, 7.70, 2.60, 227.78, 2.00],
                [12, 25.32, 0.00, 3.15, 2.58, 214.44, 1.00],
                [12, 0.85, 0.00, 5.22, 2.59, 266.02, 2.00],
                [12, 15.14, 0.00, 1.36, 2.58, 274.24, 1.00],
                [12, 0.00, 0.00, 3.53, 2.59, 274.94, 1.00],
                [12, 46.91, 0.00, 11.27, 2.58, 142.52, 2.00],
                [12, 27.43, 0.00, 0.22, 2.60, 91.79, 0.00],
                [12, 0.00, 0.00, 7.51, 2.59, 50.76, 1.00],
                [12, 0.00, 0.00, 3.75, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 1.88, 2.59, 1.03, 0.00],
                [12, 0.00, 0.00, 0.94, 2.59, 280.06, 1.00],
                [12, 0.00, 0.00, 0.47, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 0.23, 2.59, 0.00, 0.00],
                [12, 37.18, 0.00, 10.21, 2.52, 78.58, 1.00],
                [12, 0.00, 0.00, 5.22, 2.59, 78.58, 1.00],
                [12, 0.00, 0.00, 2.61, 2.59, 0.00, 0.00],
                [12, 34.70, 0.00, 8.33, 2.61, 83.47, 1.00],
                [12, 0.00, 0.00, 5.47, 2.59, 83.47, 1.00],
                [12, 10.82, 0.00, 0.27, 2.56, 6.85, 0.00],
                [12, 0.00, 0.00, 2.87, 2.59, 6.85, 0.00],
                [12, 0.00, 0.00, 1.44, 2.59, 280.06, 1.00],
                [12, 0.00, 0.00, 0.72, 2.59, 280.06, 1.00],
                [12, 13.80, 0.00, 3.48, 2.58, 13.35, 0.00],
                [12, 0.00, 0.00, 2.10, 2.59, 13.35, 0.00],
                [12, 37.11, 0.00, 9.26, 2.50, 59.78, 1.00],
                [12, 28.10, 0.00, 2.13, 2.57, 323.48, 1.00],
                [12, 10.34, 0.00, 3.87, 2.56, 257.45, 1.00],
                [12, 0.00, 0.00, 4.81, 2.59, 273.73, 2.00],
                [12, 0.00, 0.00, 2.40, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 1.20, 2.59, 280.06, 1.00],
                [12, 0.00, 0.00, 0.60, 2.59, 279.03, 1.00],
                [12, 30.67, 0.00, 8.22, 2.60, 214.61, 2.00],
                [12, 0.00, 0.00, 4.41, 2.59, 64.42, 1.00],
                [12, 0.00, 0.00, 2.21, 2.59, 279.03, 1.00],
                [12, 0.00, 0.00, 1.10, 2.59, 279.03, 1.00],
                [12, 34.35, 0.00, 8.99, 2.60, 81.55, 1.00],
                [12, 0.00, 0.00, 5.05, 2.59, 197.48, 2.00],
                [12, 0.00, 0.00, 2.52, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 1.26, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 0.63, 2.59, 279.03, 1.00],
                [12, 29.57, 0.00, 7.90, 2.57, 262.20, 2.00],
                [12, 0.00, 0.00, 4.26, 2.59, 262.20, 2.00],
                [12, 0.00, 0.00, 2.13, 2.59, 0.00, 0.00],
                [12, 0.00, 0.00, 1.07, 2.59, 0.00, 0.00],
                [12, 15.19, 0.00, 3.69, 2.60, 290.59, 1.00],
                [12, 0.00, 0.00, 2.38, 2.59, 290.59, 1.00],
                [12, 45.85, 0.00, 11.55, 2.58, 241.08, 2.00],
                [12, 0.00, 0.00, 6.96, 2.59, 37.95, 1.00],
                [12, 31.49, 0.00, 5.26, 2.60, 211.20, 2.00],
                [12, 48.46, 0.00, 7.35, 2.58, 167.78, 2.00],
            ]
          }]
          },
      ]
    });

    if (option && typeof option === "object") {
      DriveImage.setOption(option, true);
    }
  }, []);

  
  return (
    <div id="DriveImage" style={{ width: "100%", height: "90vh" }}></div>
  );
}
